export default "__VITE_ASSET__fac0b6ac__"